// Copyright (c) 2025 TrustCloud Corporation - All rights reserved.
//
// This software contains valuable confidential and proprietary information of
// TrustCloud Corporation
//
// Unauthorized use, reproduction, transmission, or distribution of this file and its
// contents is a violation of applicable law.

import { getDefaultCertificationDescription } from '../../../../lib/utils';

const getDescription = ({ selectedCertification, currentTeam, selectedDocument, programContent }) => {
  if (selectedDocument) {
    return selectedDocument.description;
  }

  const mainCertificationDescription =
    programContent.publicFacingDescriptions?.standards?.[
      `${selectedCertification?.certification?.shortName}${selectedCertification?.subtype ?? ''}`
    ];
  if (mainCertificationDescription) {
    return mainCertificationDescription;
  }

  return (
    selectedCertification?.certification?.description ??
    getDefaultCertificationDescription(
      currentTeam.name,
      selectedCertification?.certification?.shortName,
      selectedCertification?.status,
      selectedCertification?.subtype
    )
  );
};

export default getDescription;
